import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { ConfigService } from '@argalis-apps/angular-global';
import { SessionService } from '../services/session/session.service';
import { AuthService } from '../../auth/services/auth/auth.service';
import { MUser } from '@argalis-apps/models';
@Injectable({
  providedIn: 'root'
})
export class AuthorizedIntervenantGuard  {
  public userConnected: MUser.CUser;
  public listSessionsIntervenant;
  constructor(private router: Router, private authService: AuthService, private sessionService: SessionService) {
    this.userConnected = this.authService.userConnected;
    this.authService.userChange.subscribe((user: MUser.CUser) => {
      if (user && !user.login) this.userConnected = null;
      else this.userConnected = Object.assign({}, user);
    });
  }

  async canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
    const isAuthorizedToSession = await new Promise(resolve => {
      this.sessionService
        .getIfUserAuthorizedToSession(Number(this.userConnected.userInfo.id), Number(next.params['idSession']))
        .subscribe(
          (res: any) => {
            resolve(res);
          },
          err => {
            return this.router.createUrlTree(['/account/sessions']);
          }
        );
    });
    if (isAuthorizedToSession) {
      return true;
    }
    return this.router.createUrlTree(['/account/sessions']);
  }

  async canActivateChild(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
    return this.canActivate(next, state);
  }
}
